<template>
    <div v-if="link">
        <div v-if="isIos && videoId" class="youtube-thumb" :style="{ height: heightPx }" @click="openExternal">
            <img :src="thumbnail" class="youtube-thumb-img" alt="" />
            <div class="youtube-play">
                <v-icon color="white" size="56">mdi-play-circle</v-icon>
            </div>
        </div>
        <iframe
            v-else
            id="player" type="text/html"
            width="100%" :height="height"
            :src="src" class="youtube-container"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            referrerpolicy="strict-origin-when-cross-origin"
        />
        <div v-if="link.name" class="youtube-name">
            {{ link.name }}
        </div>
    </div>
</template>

<script>
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'

export default {
    name: "YoutubeIframe",
    props: {
        link: {
            type: Object,
            default: null,
        },
        height: {
            type: [Number, String],
            default: 250,
        }
    },
    computed: {
        isIos() {
            return Capacitor.getPlatform() === 'ios'
        },
        videoId(vm = this) {
            return vm.link?.videoId || null
        },
        thumbnail(vm = this) {
            return vm.videoId ? `https://img.youtube.com/vi/${vm.videoId}/hqdefault.jpg` : null
        },
        heightPx(vm = this) {
            return typeof vm.height === 'number' ? `${vm.height}px` : vm.height
        },
        src(vm = this) {
            return vm.videoId ? `https://www.youtube.com/embed/${vm.videoId}` : null
        }
    },
    methods: {
        async openExternal() {
            const vm = this
            if (!vm.videoId) return
            try {
                await Browser.open({ url: `https://www.youtube.com/watch?v=${vm.videoId}`, presentationStyle: 'popover' })
            } catch (e) { /* ignore */ }
        }
    }
}
</script>

<style scoped>

.youtube-container {
    display: block;
    border-radius: 8px;
    border: 0;
}

.youtube-thumb {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    background: #000;
}

.youtube-thumb-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.youtube-play {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.youtube-name {
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
}

</style>
